// @flow

import React, { PureComponent } from 'react';
import type { Element } from 'react';
import PropTypes from 'prop-types';
// Helpers
import classNames from 'classnames';
// Helpers
import TagHtml from 'Common/TagHtml';

/**
 *    Label React presentational component.
 */
export default class Label extends PureComponent<*, *> {
  /**
   *    Props implementation.
   */
  static propTypes = {
    extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    content: PropTypes.string.isRequired,
    attrs: PropTypes.object,
    classLabel: PropTypes.string
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render(): Element<*> {
    const { classLabel, content, extendStyle } = this.props;
    return (
      <TagHtml
        {...this.props}
        content={content}
        bold
        className={classNames(classLabel, extendStyle)}
        tag="label"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/Common/Label/index.js